import request from "ynf-core-engine/request";
import { configHook } from "@utils";
/**
 * getTplList
 * @param param0
 * @returns
 */
export async function getTplList ({ params = {}, data = {}, ...rest } = {}) {
  /**
   * 默认查询参数
   */
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {}
  };
  defaultQuery.params = configHook(params, defaultQuery.params);
  defaultQuery.data = configHook(data, defaultQuery.data);
  // /iuap-metadata-import/exceltrain/template/getTplList
  try {
    const res = await request({
      url: `/iuap-metadata-import/exceltrain/template/getTplList`,
      method: "post",
      ...defaultQuery,
      ...rest
    });
    return res;
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * getTplList
 * @param param0
 * @returns
 */
export async function downLoadTpl ({ params = {}, data = {}, ...rest } = {}) {
  /**
   * 默认查询参数
   */
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {}
  };
  defaultQuery.params = configHook(params, defaultQuery.params);
  defaultQuery.data = configHook(data, defaultQuery.data);
  try {
    // /iuap-yonbuilder-runtime/
    const res = await request(
      {
        method: "post",
        url: `/mdf-node/qtmProxy/billtemp/export`,
        ...defaultQuery,
        ...rest,
        responseType: "blob"
      },
      {
        proxy: false,
        rawResponse: false,
        handleErrCode: true,
        silent: true
      }
    );
    return res;
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * billImport
 * @param param0
 * @returns
 */
export async function billImport ({ params = {}, data = {}, ...rest } = {}) {
  /**
   * 默认查询参数
   */
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {}
  };
  defaultQuery.params = configHook(params, defaultQuery.params);
  defaultQuery.data = configHook(data, defaultQuery.data);
  try {
    const res = await request(
      {
        method: "post",
        url: `/iuap-metadata-import/exceltrain/bill/billImport`,
        ...defaultQuery,
        ...rest
      },
      {
        proxy: false,
        rawResponse: false,
        handleErrCode: true,
        silent: true
      }
    );
    return res;
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * checkProcess
 * @param param0
 * @returns
 */
export async function checkProcess ({ params = {}, controller = '', data = {}, ...rest } = {}) {
  /**
   * 默认查询参数
   */
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {}
  };
  defaultQuery.params = configHook(params, defaultQuery.params);
  defaultQuery.data = configHook(data, defaultQuery.data);
  try {
    const res = await request(
      {
        method: "post",
        url: `/iuap-metadata-import/exceltrain${controller}`,
        ...defaultQuery,
        ...rest
      },
      {
        proxy: false,
        rawResponse: false,
        handleErrCode: true,
        silent: true
      }
    );
    return res;
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * checkProcess
 * @param param0
 * @returns
 */
export async function dispatchImportTask ({ params = {}, data = {}, ...rest } = {}) {
  /**
   * 默认查询参数
   */
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {}
  };
  defaultQuery.params = configHook(params, defaultQuery.params);
  defaultQuery.data = configHook(data, defaultQuery.data);
  try {
    const res = await request(
      {
        method: "post",
        url: `/iuap-metadata-import/exceltrain/dispatchImportTask`,
        ...defaultQuery,
        ...rest
      },
      {
        proxy: false,
        rawResponse: false,
        handleErrCode: true,
        silent: true
      }
    );
    return res;
  } catch (err) {
    return Promise.reject(err);
  }
}

/**
 * checkProcess
 * @param param0
 * @returns
 */
export async function toDrew ({ params = {}, controller = '', data = {}, ...rest } = {}) {
  /**
   * 默认查询参数
   */
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {}
  };
  defaultQuery.params = configHook(params, defaultQuery.params);
  defaultQuery.data = configHook(data, defaultQuery.data);
  try {
    const res = await request(
      {
        method: "post",
        url: `/iuap-metadata-import/exceltrain${controller}`,
        ...defaultQuery,
        ...rest
      },
      {
        proxy: false,
        rawResponse: false,
        handleErrCode: true,
        silent: true
      }
    );
    return res;
  } catch (err) {
    return Promise.reject(err);
  }
}